// Shared style fragments for Nextmv components.
// Import and spread into styledComponent objects to avoid duplication.

import theme from '../../theme';

// Dropdown menu styles (overlay + content container)
const dropdownStyles = {
  '& .dropdown-container': {
    position: 'relative',
    display: 'inline-block',
  },

  '& .dropdown-overlay': {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9,
  },

  '& .dropdown-content': {
    display: 'none',
    position: 'absolute',
    right: 0,
    background: theme.colors.bgCard,
    minWidth: '160px',
    boxShadow: theme.shadows.dropdown,
    zIndex: 10,
    borderRadius: theme.radii.input,
    overflow: 'hidden',
    top: '100%',
    marginTop: theme.spacing.dropdownOffset,
  },

  '& .dropdown-content.show': {
    display: 'block',
  },
};

export default dropdownStyles;
